const getCategory = (category) =>
  [category.categoryName, category.subCategory1Name, category.subCategory2Name]
    .filter(Boolean)
    .join(" > ");

export default getCategory;
